import { translations, normalizeLang } from "./i18n";

// `-u-nu-latn` pins Western digits under the Arabic locale — see the
// matching comment on formatCreated in ./transcript.js for why.
export function defaultRecordingName(lang) {
  const resolved = normalizeLang(lang);
  const locale = resolved === "ar" ? "ar-u-nu-latn" : "en-GB";
  const now = new Date();
  const date = now.toLocaleDateString(locale, { month: "short", day: "numeric", year: "numeric" });
  const time = now.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" });
  return `${translations[resolved].ui.recordingNamePrefix} — ${date} ${time}`;
}
